export default __webpack_public_path__ + "static/media/0xf4b8888427b00d7caf21654408b7cba2ecf4ebd9.b0b6f239.svg";